import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetUnitDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Unit/GetDetail?` + params, null);

export const GetUnitList = (params: any) =>
  GET_ENC(`${BASE_URL}/api/Unit/GetList?` + params, null);

export const CreateUnit = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Unit/Create`, data);

export const UpdateUnit = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Unit/Update`, data);    

export const DeleteUnit = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Unit/Delete`, data);
